import { render, staticRenderFns } from "./GridViewSmall.vue?vue&type=template&id=05900817&"
import script from "./GridViewSmall.vue?vue&type=script&lang=ts&"
export * from "./GridViewSmall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports